import React from 'react';
import DamFolderList from './DamFolderGroup/DamFolderList';

function DamFolderGroup() {
  return <DamFolderList />;
}

export default DamFolderGroup;
